var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 29,
    height: 29,
    rx: 3.5,
    fill: "#D0BCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 29,
    height: 29,
    rx: 3.5,
    stroke: "#D0BCFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1836_3501)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(5.5 6)",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6117 16.1876L21.1475 19.7234L17.6117 23.2592C17.4554 23.4155 17.2435 23.5034 17.0225 23.5034H14.6667C14.4457 23.5034 14.2337 23.4156 14.0774 23.2593C13.9211 23.1031 13.8333 22.8911 13.8333 22.6701V20.3126C13.8334 20.0916 13.9212 19.8797 14.0775 19.7234L17.6117 16.1876ZM19.6667 7.66675C20.0871 7.66662 20.4921 7.82542 20.8005 8.11133C21.1088 8.39724 21.2976 8.78912 21.3292 9.20841L21.3333 9.33341V12.6834C20.7038 12.564 20.0551 12.5915 19.438 12.7638C18.8208 12.9361 18.2517 13.2485 17.775 13.6767L17.6117 13.8309L12.8983 18.5451C12.4699 18.9735 12.2117 19.543 12.1717 20.1476L12.1658 20.3126V22.6701C12.1659 22.8965 12.1967 23.1219 12.2575 23.3401L12.3075 23.5001H9.66667C9.24619 23.5002 8.84119 23.3414 8.53288 23.0555C8.22456 22.7696 8.0357 22.3777 8.00417 21.9584L8 21.8334V9.33341C7.99987 8.91293 8.15867 8.50794 8.44458 8.19962C8.73049 7.89131 9.12237 7.70245 9.54167 7.67091L9.66667 7.66675H19.6667ZM22.3258 15.0092C22.558 15.2414 22.7422 15.517 22.8679 15.8204C22.9935 16.1237 23.0582 16.4488 23.0582 16.7772C23.0582 17.1055 22.9935 17.4306 22.8679 17.734C22.7422 18.0373 22.558 18.3129 22.3258 18.5451L18.7917 15.0084C19.2605 14.5397 19.8963 14.2764 20.5592 14.2764C21.2221 14.2764 21.8578 14.5397 22.3267 15.0084L22.3258 15.0092ZM14.6667 11.0001H11.3333C11.1123 11.0001 10.9004 11.0879 10.7441 11.2442C10.5878 11.4004 10.5 11.6124 10.5 11.8334C10.5 12.0544 10.5878 12.2664 10.7441 12.4227C10.9004 12.5789 11.1123 12.6667 11.3333 12.6667H14.6667C14.8877 12.6667 15.0996 12.5789 15.2559 12.4227C15.4122 12.2664 15.5 12.0544 15.5 11.8334C15.5 11.6124 15.4122 11.4004 15.2559 11.2442C15.0996 11.0879 14.8877 11.0001 14.6667 11.0001Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1836_3501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.576b24991113db9abf3060fc1a946a56.svg";
export { ForwardRef as ReactComponent };